import { render, staticRenderFns } from "./th-ordering-button.vue?vue&type=template&id=049e67f5&scoped=true"
import script from "./th-ordering-button.vue?vue&type=script&lang=js"
export * from "./th-ordering-button.vue?vue&type=script&lang=js"
import style0 from "./th-ordering-button.vue?vue&type=style&index=0&id=049e67f5&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049e67f5",
  null
  
)

export default component.exports